<template>
  <div class="page-container">
    <el-card>
      <app-filter
        :filter-list="table_filter"
        default-label-width="100px"
        @search="onSearch"
      />
    </el-card>
    <el-card class="mt-20">
      <div class="flex justify-between mb-20">
        <div>
          <el-select v-model="batch_config.value" size="mini" class="mr-20" placeholder="请选择批量操作">
            <el-option v-for="item in batch_config.options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button size="mini" type="primary" @click="onBatch">批量操作</el-button>
        </div>
        <el-button type="success" size="mini" @click="onPull">同步</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :table-props="{ 'max-height': '550px' }"
        :tablep="table_params"
        :is-request="false"
        :page-size="10"
        :get-data="getCampaignList"
        :is-row-click="false"
        :check="true"
        @select-tr="onSelectionChange"
      />
    </el-card>
    <el-drawer
      :title="drawer_config.title"
      :visible.sync="drawer_config.is_show"
      size="1000px"
    >
      <multiple-app-form
        v-if="drawer_config.is_show"
        ref="multiple_app_form"
        v-loading="drawer_config.is_loading"
        :form-fields="drawer_config.form_fields"
        @confirm="drawer_config.confirm"
        @cancel="drawer_config.cancel"
      >
        <template #custom="{form_item, form_key}">
          <schedule-time
            v-if="form_key === 'time_period'"
            preele="multiple-app-form-content"
            :value="form_item.value"
          />
        </template>
      </multiple-app-form>
    </el-drawer>
  </div>
</template>

<script>
import { getMediasListApi } from '@/api/medias';
import { CHANNEL_INTERFACE_TYPE, TIME_PERIOD_LENGTH } from '@/enums';
import {
  getCampaignListApi,
  pullCampaignStatusApi,
  getCampaignDetailApi,
  editCampaignApi,
  updateCampaignStatusApi,
  deteleCampaignApi,
} from '@/api/campaign';
import { getSiteSetApi } from '@/api/tool/site-set';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { getDeepBidTypeApi } from '@/api/tool/deep-bid-type';
import store from '@/store';
import { clone } from '@/utils';
import calculator from '@/utils/calculator';
import { transformSelectedTimeToTimeSeries } from '@/tools/form';

import getFormFields from './model/form-fields.js';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
    'multiple-app-form': () => import('../components/multiple-app-form'),
    'schedule-time': () => import('@/components/schedule-time'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      table_filter: require('./model/table-filter.js')(this),
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 表格多选数据 */
      table_multiple_selection: [],
      /** 批量操作 */
      batch_config: {
        value: 'del',
        options: [
          {
            label: '批量删除',
            value: 'del',
          },
        ],
      },
      /** 弹窗配置 */
      drawer_config: {
        is_show: false,
        is_loading: false,
        title: '新增',
        id: null,
        form_fields: {},
        confirm: () => {},
      },
      /** 枚举表 */
      enum_map: {
        delivery_platform_type: {},
        site_sets: {},
        price_type: {},
        price_strategy: {},
        budget_optimize_switch: {
          'ON': '启用',
          'OFF': '不启用',
        },
        status: {
          'ENABLE': '开启',
          'DISABLE': '关闭',
        },
      },
    };
  },
  async created() {
    this.table_filter.advertiser_id.options = await this.getAdvertiserList(CHANNEL_INTERFACE_TYPE.JRTT);
    this.setEnumMap(CHANNEL_INTERFACE_TYPE.JRTT);
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 搜索条件
     */
    onSearch(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /**
     * 同步
     */
    onPull() {
      const { channel_interface, advertiser_id } = this.table_filter;
      if (!advertiser_id.value) {
        this.$message.warning('请选择广告主账户');
        return;
      }
      pullCampaignStatusApi({
        channel_interface: channel_interface.value,
        advertiser_id: advertiser_id.value,
      }).then(({ message }) => {
        this.$message.success(message || '同步成功');
        this.$refs.table.seekTable();
      });
    },
    /**
     * 编辑
     * @param {Object} row 当前行数据
     */
    async onEdit(row) {
      const { channel_interface, advertiser_id } = this.table_params;
      const data = clone(row);
      const { id } = data;
      Object.assign(this.drawer_config, {
        is_show: true,
        is_loading: true,
        title: '编辑',
        form_fields: getFormFields(),
        confirm: (params) => {
          const {
            schedule_form: {
              schedule_type,
              delivery_date,
              time_period_type,
              schedule_time,
              time_period,
            },
            budget_and_bid_form: {
              daily_budget_type,
              daily_budget,
              cpa_bid,
              roi_goal,
            },
          } = params;
          const payload = {
            channel_interface,
            advertiser_id,
            schedule_type,
            ...(schedule_type === 'SCHEDULE_START_END' && { begin_date: delivery_date[0] }),
            ...(schedule_type === 'SCHEDULE_START_END' && { end_date: delivery_date[1] }),
            time_period_type,
            ...(time_period_type === 'TIME_PERIOD_ALL' && { time_period: new Array(TIME_PERIOD_LENGTH.HALF_HOUR).fill(1).join('') }),
            ...(time_period_type === 'TIME_PERIOD_DAY_SPECIFIC' && { time_period: transformSelectedTimeToTimeSeries(schedule_time.start, schedule_time.end) }),
            ...(time_period_type === 'TIME_PERIOD_HOUR_SPECIFIC' && { time_period: time_period.schedule_time_content }),
            ...(daily_budget_type && { daily_budget_type }),
            ...(daily_budget_type === 'BUDGET_MODE_DAY' && { daily_budget: calculator.times(daily_budget, 100) }),
            ...(cpa_bid && { cpa_bid: calculator.times(cpa_bid, 100) }),
            ...(roi_goal && { roi_goal }),
          };
          editCampaignApi(id, payload).then(({ message }) => {
            this.$message.success(message || '编辑成功');
            this.drawer_config.is_show = false;
            this.$refs.table.seekTable();
          });
        },
        cancel: () => {
          this.drawer_config.is_show = false;
        },
      });

      const campaign_detail = await getCampaignDetailApi(id, { channel_interface, advertiser_id });
      const { name: campaign_name } = data;
      const {
        begin_date,
        end_date,
        time_period,
        daily_budget_type,
        daily_budget,
        price_type,
        price_strategy,
        cpa_bid,
        delivery_platform_type,
        delivery_content_id,
        jrtt_params: {
          convert_goal,
          deep_convert_goal,
          deep_bid_type,
          budget_optimize_switch,
          roi_goal,
          delivery_mode,
          app_promotion_type,
        } = {},
      } = campaign_detail;

      const {
        base_form: {
          config: {
            campaign_name: campaign_name_field,
          },
        },
        schedule_form: {
          config: {
            schedule_type: schedule_type_field,
            delivery_date: delivery_date_field,
            time_period_type: time_period_type_field,
            schedule_time: schedule_time_field,
            time_period: time_period_field,
          },
        },
        budget_and_bid_form: {
          config: {
            daily_budget_type: daily_budget_type_field,
            daily_budget: daily_budget_field,
            price_type: price_type_field,
            price_strategy: price_strategy_field,
            convert_goal: convert_goal_field,
            deep_convert_goal: deep_convert_goal_field,
            deep_bid_type: deep_bid_type_field,
            budget_optimize_switch: budget_optimize_switch_field,
            cpa_bid: cpa_bid_field,
            roi_goal: roi_goal_field,
          },
        },
      } = this.drawer_config.form_fields;
      const mapTuple = [
        // 广告名称
        () => {
          Object.assign(campaign_name_field, { value: campaign_name });
        },
        // 投放日期
        () => {
          const is_has_date = begin_date && end_date;

          Object.assign(schedule_type_field, {
            ...(is_has_date && { value: 'SCHEDULE_START_END' }),
            on: {
              change: () => {
                const is_start_end = schedule_type_field.value === 'SCHEDULE_START_END';
                delivery_date_field.hidden = !is_start_end;
              },
            },
          });

          Object.assign(delivery_date_field, {
            ...(is_has_date && { value: [begin_date, end_date] }),
          });

          schedule_type_field.on.change();
        },
        // 投放时间
        () => {
          const is_has_time = time_period;

          Object.assign(time_period_type_field, {
            ...(is_has_time && { value: 'TIME_PERIOD_HOUR_SPECIFIC' }),
            on: {
              change: () => {
                const is_day_specific = time_period_type_field.value === 'TIME_PERIOD_DAY_SPECIFIC';
                const is_hour_specific = time_period_type_field.value === 'TIME_PERIOD_HOUR_SPECIFIC';
                schedule_time_field.hidden = !is_day_specific;
                time_period_field.hidden = !is_hour_specific;
              },
            },
          });

          Object.assign(time_period_field, { ...(is_has_time && { value: { schedule_time_content: time_period }}) });

          time_period_type_field.on.change();
        },
        // 日预算
        () => {
          Object.assign(daily_budget_type_field, {
            value: daily_budget_type,
            on: {
              change: () => {
                const is_day = daily_budget_type_field.value === 'BUDGET_MODE_DAY';
                daily_budget_field.hidden = !is_day;
              },
            },
          });

          Object.assign(daily_budget_field, { ...(daily_budget && { value: calculator.div(daily_budget, 100) }) });

          daily_budget_type_field.on.change();
        },
        // 出价方式
        () => {
          price_type && Object.assign(price_type_field, {
            hidden: false,
            value: this.enum_map.price_type[price_type],
          });
        },
        // 出价策略
        () => {
          price_strategy && Object.assign(price_strategy_field, {
            hidden: false,
            value: this.enum_map.price_strategy[price_strategy],
          });
        },
        // 优化目标
        async() => {
          if (convert_goal) {
            const convert_goal_enum = await this.getConvertGoalEnumVal({
              jrtt_params: {
                filtering: {
                  delivery_mode,
                  delivery_platform_type,
                  delivery_content_id,
                  app_promotion_type,
                },
              },
            });

            Object.assign(convert_goal_field, {
              hidden: false,
              value: convert_goal_enum[convert_goal],
            });
          }
        },
        // 深度优化目标
        async() => {
          if (convert_goal && deep_convert_goal) {
            const deep_convert_goal_enum = await this.getDeepConvertGoalEnumVal({
              jrtt_params: {
                filtering: {
                  delivery_mode,
                  delivery_platform_type,
                  delivery_content_id,
                  app_promotion_type,
                  convert_goal,
                },
              },
            });

            Object.assign(deep_convert_goal_field, {
              hidden: false,
              value: deep_convert_goal_enum[deep_convert_goal],
            });
          }
        },
        // 深度优化方式
        async() => {
          if (convert_goal && deep_bid_type) {
            const deep_bid_type_enum = await this.getDeepBidTypeEnumVal({
              jrtt_params: {
                filtering: {
                  delivery_mode,
                  delivery_platform_type,
                  convert_goal,
                  deep_convert_goal,
                },
              },
            });

            Object.assign(deep_bid_type_field, {
              hidden: false,
              value: deep_bid_type_enum[deep_bid_type],
            });
          }
        },
        // 预算择优分配
        () => {
          budget_optimize_switch && Object.assign(budget_optimize_switch_field, {
            hidden: false,
            value: this.enum_map.budget_optimize_switch[budget_optimize_switch],
          });
        },
        // 优化目标出价
        () => {
          cpa_bid && Object.assign(cpa_bid_field, {
            hidden: false,
            value: calculator.div(cpa_bid, 100),
          });
        },
        // 深度ROI系数出价
        () => {
          roi_goal && Object.assign(roi_goal_field, {
            hidden: false,
            value: roi_goal,
          });
        },
      ];

      mapTuple.forEach((handler) => handler());
      this.drawer_config.is_loading = false;
    },
    /**
     * 切换状态
     * @param {Object} row 当前行数据
     */
    onSwitch(row) {
      const { id, name, status } = row;
      const is_enable = status === 'ENABLE';
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'mb-10 color-red' }, name),
        h('div', { class: 'mb-10' }, `是否将当前已选中的广告设置为${is_enable ? '关闭' : '开启'}状态`),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { channel_interface, advertiser_id } = this.table_filter;
        const params = {
          channel_interface: channel_interface.value,
          advertiser_id: advertiser_id.value,
          status: is_enable ? 'DISABLE' : 'ENABLE',
        };
        updateCampaignStatusApi(id, params).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 删除
     * @param {string[]} ids 当前行数据
     */
    onDel(ids) {
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        ...((ids || []).map(id => h('div', { class: 'mb-10 color-red' }, id))),
        h('div', { class: 'mb-10' }, '是否删除当前已选中的广告'),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { channel_interface, advertiser_id } = this.table_filter;
        const params = {
          channel_interface: channel_interface.value,
          advertiser_id: advertiser_id.value,
          ids,
        };
        deteleCampaignApi(params).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
          this.table_multiple_selection.splice(0);
        });
      });
    },
    /** 批量操作 */
    onBatch() {
      switch (this.batch_config.value) {
        case 'del':
          this.onBatchDel();
          break;
        default:
          break;
      }
    },
    /**
     * 批量删除
     */
    onBatchDel() {
      if (!this.table_multiple_selection.length) {
        this.$message.warning('请选择广告！');
        return;
      }
      const ids = this.table_multiple_selection.map(({ id }) => id);
      this.onDel(ids);
    },
    /**
     * 表格多选事件
     * @param {Object[]} rows 当前选中数据
     */
    onSelectionChange(rows) {
      this.table_multiple_selection = rows;
    },
    /**
     * 获取广告列表
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getCampaignList(params) {
      return new Promise((resolve, reject) => {
        getCampaignListApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @param {string} type 渠道接口
     * @returns {Promise<Object[]>}
     */
    getAdvertiserList(type) {
      return new Promise((resolve, reject) => {
        getMediasListApi({
          type,
          is_list: true,
        }).then(res => {
          const result = res.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取版位枚举表
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getSiteSetEnumVal(params) {
      return new Promise((resolve, reject) => {
        getSiteSetApi(params).then(({ list = [] }) => {
          const result = {};
          list.forEach(({ id, name }) => {
            Object.assign(result, { [id]: name });
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取优化目标枚举
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getConvertGoalEnumVal(params) {
      const { channel_interface, advertiser_id } = this.table_params;
      return new Promise((resolve, reject) => {
        getConvertGoalListApi({
          channel_interface,
          advertiser_id,
          ...params,
        }).then(({ list = [] }) => {
          const result = {};
          list.forEach(({ id, name }) => {
            Object.assign(result, { [id]: name });
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取深度优化目标枚举
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getDeepConvertGoalEnumVal(params) {
      const { channel_interface, advertiser_id } = this.table_params;
      return new Promise((resolve, reject) => {
        getDeepConvertGoalApi({
          channel_interface,
          advertiser_id,
          ...params,
        }).then(({ list = [] }) => {
          const result = {};
          list.forEach(({ id, name }) => {
            Object.assign(result, { [id]: name });
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 获取深度优化方式枚举
     * @param {Object} params 请求参数
     * @returns {Promise<Object>}
     */
    getDeepBidTypeEnumVal(params) {
      const { channel_interface, advertiser_id } = this.table_params;
      return new Promise((resolve, reject) => {
        getDeepBidTypeApi({
          channel_interface,
          advertiser_id,
          ...params,
        }).then(({ list = [] }) => {
          const result = {};
          list.forEach(({ id, name }) => {
            Object.assign(result, { [id]: name });
          });
          resolve(result);
        }).catch(reject);
      });
    },
    /**
     * 设置枚举表
     * @param {string} channel_interface 渠道接口
     */
    async setEnumMap(channel_interface) {
      const {
        api_fusion_delivery_platform_type,
        api_fusion_price_type,
        api_fusion_price_strategy,
      } = store.getters[`${channel_interface}EnumVal`];
      Object.assign(this.enum_map, {
        delivery_platform_type: api_fusion_delivery_platform_type,
        price_type: api_fusion_price_type,
        price_strategy: api_fusion_price_strategy,
      });
    },
  },
};
</script>
